import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MainComponent } from './main/main.component';
import { MainRoutingModule } from './main-routing.module';
import { LoginComponent } from './login/login.component';
import { InicioComponent } from './inicio/inicio.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    MainComponent,
    LoginComponent,
    InicioComponent,    
  ],
  imports: [
    SharedModule,
    MainRoutingModule,
    FormsModule
  ]
})
export class MainModule { }
